/**
 * MỘT nguồn biến CSS màu theo ngành cho cả hai app (v0.23.0). Mini App giữ `apMauNganh` riêng (5 biến); web quầy dùng
 * `apMauQuay` (apps/admin/src/mau-quay.ts) và khung xem trước ở Cấu hình → Thông tin tiệm — đều đi qua `bienCssNganh`.
 *
 * Chạy được trong trình duyệt và Mini App dựng es2015: chỉ import `./nganh.ts`, không bigint, không API Node.
 */
import { GIAO_DIEN_MAC_DINH, type MauNganh, NGANH, type NganhTiem } from './nganh.ts'

export type BienMau = readonly (readonly [string, string])[]

/** `#rrggbb` → `rgb(r g b / 0.25)` (bóng nút chính). */
function bongTu(hex: string): string {
  const r = Number.parseInt(hex.slice(1, 3), 16)
  const g = Number.parseInt(hex.slice(3, 5), 16)
  const b = Number.parseInt(hex.slice(5, 7), 16)
  return `rgb(${r} ${g} ${b} / 0.25)`
}

/**
 * 7 biến: `--sp-primary`, `-press`, `-soft`, `-line`, `--sp-bia-1`, `--sp-bia-2`, `--sp-primary-bong`.
 * `null` (chưa biết ngành / ngành lạ) → bộ `khac` = xanh SAPA.
 */
export function bienCssNganh(n: NganhTiem | null): BienMau {
  const m: MauNganh = n === null ? GIAO_DIEN_MAC_DINH.mau : NGANH[n].mau
  return [
    ['--sp-primary', m.primary],
    ['--sp-primary-press', m.press],
    ['--sp-primary-soft', m.soft],
    ['--sp-primary-line', m.line],
    ['--sp-bia-1', m.bia1],
    ['--sp-bia-2', m.bia2],
    ['--sp-primary-bong', bongTu(m.primary)],
  ]
}

/** Phần tử có `style` kiểu DOM (đối tượng giả trong test cũng khớp). */
export interface CoStyle {
  style: {
    setProperty(k: string, v: string): void
    removeProperty(k: string): void
  }
}

export function apBienCss(el: CoStyle, bien: BienMau): void {
  for (const [k, v] of bien) el.style.setProperty(k, v)
}

export function boBienCss(el: CoStyle, bien: BienMau): void {
  for (const [k] of bien) el.style.removeProperty(k)
}
